<template>
  <footer>
    <div class="bg-black text-white">
      <div class="container mx-auto divide-y divide-neutral-600">
        <div class="grid lg:grid-cols-6 gap-4 py-4 lg:py-12">
          <div class="col-span-2 space-y-4">
            <AppLogoIcon class="block w-20 h-20"></AppLogoIcon>
            <p>
              The best digital marketplace for crypto collectibles and
              non-fungible tokens (NFTs). Buy, sell, and discover exclusive
              digital items.
            </p>
          </div>
        </div>

        <div
          class="py-4 w-full flex items-center justify-between text-xs text-neutral-400"
        >
          <p class="">© 2022 Whitelabel Solutions. All Rights Reserved.</p>
          <ul class="flex space-x-4">
            <li><router-link to="/">Privacy Policy</router-link></li>
            <li><router-link to="/">Terms of Service</router-link></li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import AppLogoIcon from "@/common/components/Icon/AppLogoIcon";
export default {
  components: { AppLogoIcon },
};
</script>
